module.exports = __webpack_public_path__ + "img/IMG_2243.8d291dd7.jpg";